<template>
  <div class="app-section">
    <div class="icon-app">
      <h2>تجربه آسان و سریع خرید ارز در اپلیکیشن موبایل دریک</h2>
      <div class="logo-app">
        <div class="logo-row">
          <img src="../../assets/Home/googleplay.png" alt="">
          <img src="../../assets/Home/bazar.png" alt="">
        </div>
        <div class="logo-row">
          <img src="../../assets/Home/sibapp.png" alt="">
          <img src="../../assets/Home/iapps.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "the-app-section"
}
</script>

<style lang="scss" scoped>
.app-section {
  background-image: url("../../assets/Home/phonemockup.png");
  background-repeat: no-repeat;
  background-size: auto;
  background-position: 80px center;
  display: flex;
  flex-direction: column;
  gap: 80px;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  min-height: 600px;
  margin: 130px 0;

  .icon-app {
    display: flex;
    flex-direction: column;
    gap: 80px;
    justify-content: center;
    align-items: flex-end;
    position: relative;
    right: 100px;
    color: white;
    
    h2{
      font-size: clamp(16px , 2vw , 24px);
      padding: 0 10px;
    }
  }

  .logo-app {
    display: flex;
    flex-direction: column;
    gap: 50px;

    .logo-row{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 50px;
      flex-wrap: wrap;
      
      img{
        cursor: pointer;
      }
    }
  }
}

@media (max-width: 500px) {
  .icon-app{
    right: 0!important;
    align-items: center !important;
  }
}

@media (max-width: 600px) {
  .app-section{
    background-image: none !important;
    align-items: center !important;
  }
}

@media (max-width: 992px) {
  .icon-app{
    right: 5px!important;
  }
}

@media (max-width: 450px) {
  .app-section{
    margin: 10px;
  }
 .logo-row{
   align-items: center !important;
   justify-content: center !important;
 }
}
</style>